import React from 'react';
import PropTypes from 'prop-types';

import OEObjectModelBitCheckboxListCell from './cells/oe-object-model-bit-checkbox-list-cell';
import OEObjectModelBoolValueCell from './cells/oe-object-model-bool-value-cell';
import OEObjectModelDropdownCell from './cells/oe-object-model-dropdown-cell';
import OEObjectModelGroupCell from './cells/oe-object-model-group-cell';
import OEObjectModelNumberValueCell from './cells/oe-object-model-number-value-cell';
import OEObjectModelStringArrayValueCell from './cells/oe-object-model-string-array-value-cell';
import OEObjectModelStringValueCell from './cells/oe-object-model-string-value-cell';
import OEObjectModelValueCell from './cells/oe-object-model-value-cell';
import OEObjectModelVecValueCell from './cells/oe-object-model-vec-value-cell';
import {OEObjectModelValueTypes, OEObjectModelValueEditTypes, OEObjectModelValueEditDecls} from './oe-object-model-value-edit-model';

export default function OEObjectModelValueCellFactory(props)   {
    const Types = OEObjectModelValueTypes;

    const isInteger = [Types.integer, Types.unsignedInteger, Types.integer64, Types.unsignedInteger64].includes(props.type);

    if(props.type === Types.string)  {

        return <OEObjectModelStringValueCell {...props}/>

    } else if(props.type === Types.bool)  {

        return <OEObjectModelBoolValueCell {...props}/>

    } else if(isInteger || props.type === Types.float)  {

        if(isInteger && props.editType == OEObjectModelValueEditTypes.dropdown)  return <OEObjectModelDropdownCell {...props}/>

        if(isInteger && props.editType == OEObjectModelValueEditTypes.bitCheckboxList)  return <OEObjectModelBitCheckboxListCell {...props}/>

        return <OEObjectModelNumberValueCell {...props}/>

    } else if(props.type === Types.vec2 || props.type === Types.vec2i)  {

        return <OEObjectModelVecValueCell {...props}/>

    } else if(props.type === Types.vec3 || props.type === Types.vec3i)  {

        return <OEObjectModelVecValueCell {...props}/>

    } else if(props.type === Types.stringArray)  {

        return <OEObjectModelStringArrayValueCell {...props}/>

    } else if(props.type === Types.group)  {

        return <OEObjectModelGroupCell {...props}/>

    } else {

        return <OEObjectModelValueCell {...props}/>
    }
}

OEObjectModelValueCellFactory.defaultProps = Object.assign({
    disabled:                   false,
}, OEObjectModelValueCell.defaultProps);

OEObjectModelValueCellFactory.defaultProps.showType = undefined;        // showType default distinguishes for cell types

OEObjectModelValueCellFactory.propTypes = Object.assign({
    cellClassName:              PropTypes.string,
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    deferMinMaxConstraint:      PropTypes.bool,
    allowPartialUndefined:      PropTypes.bool,
    undefinedEditable:          PropTypes.bool,
    min:                        PropTypes.number,
    max:                        PropTypes.number,
    step:                       PropTypes.number,
    entries:                    OEObjectModelValueEditDecls.dropdownCellEntries,
    defaultDropdownTitle:       PropTypes.string,
    labels:                     OEObjectModelValueEditDecls.modelItemLabels,
    value:                      PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.object, PropTypes.array]),
    subItems:                   PropTypes.arrayOf(PropTypes.object)
}, OEObjectModelValueCell.propTypes);